/* eslint-disable react-hooks/exhaustive-deps */
// DocCategoryConfig.js
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';

import { isTokenPresent } from '../utils/auth';
import useSpecialToken from '../utils/hooks/useSpecialToken';
import apiRoutes from '../utils/hooks/apiRoutes';
import Model from '../utils/Interface/Model';

import TabsNav from "../components/TabsNav";
import InputField from '../components/InputField';
import Menu from "../components/Menu"
import "../style/css/doccategoryconfig.css"
import Header from "../components/Header";
import Button from "../components/Button";
import TableSimple from "../components/TableSimple";
import ButtonSave from '../components/ButtonSave';
import PopUp from '../components/PopUp';

function DocCategoryConfig() {



  const [data, setData] = useState([]);
  const [dataModels, setDataModels] = useState<Model[]>([]);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null); 
  const [selectedCategoryName, setSelectedCategoryName] = useState('');
  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => setBasicModal(!basicModal);
  const [basicModal2, setBasicModal2] = useState(false);
  const toggleOpen2 = () => setBasicModal2(!basicModal2);

  const labels = [
    {
      "title": "Nom Catégorie ",
    },
  ];

  const { userName, specialToken } = useSpecialToken();
  
//functions useEffect & fetchData
  useEffect(() => {
    if (!isTokenPresent()) {
      window.location.href = '/'; 
    }
    fetchData();
    fetchDataModels();
  }, []); 


  async function fetchData() {

    const headers = {
    'Content-Type' : 'application/json',
    }

    try {
      const response = await fetch(apiRoutes.documentsCategoriesGetAll, {headers});

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const jsonData = await response.json();

      setData(jsonData);

    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  }

  async function fetchDataModels() {

    const headers = {
    'Content-Type' : 'application/json',
    }

    try {
      const response = await fetch(apiRoutes.documentsModelsGetAll, {headers});

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const jsonData = await response.json();
      setDataModels(jsonData);
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  }
//functions handleClick, save, put and delete

  const handleSave = async () => {
    try {
      const requestBody = {
        name: newCategoryName,
        glpi_user_id_tech: 2, 
      };


      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }

      const response = await fetch(apiRoutes.documentsCategoriesPost, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'special-token': specialToken
        },
        body: JSON.stringify(requestBody),
      });
  
      if (!response.ok) {
        throw new Error('Erreur lors de l\'ajout de la catégorie');
      }
alert('Catégorie ajoutée avec succès !')
      setNewCategoryName("  ");
      window.location.reload();
    } catch (error) {
      console.error('Erreur lors de l\'ajout de la catégorie :', error);
    }
  };

  const handleEdit = (id: number, name: string) => {
    setSelectedCategoryId(id);
    setSelectedCategoryName(name);
    toggleOpen2();
  };

  const handleEditPut = async () => {
    try {
      if (!selectedCategoryId) {
        throw new Error('Aucune catégorie sélectionnée.');
      }

      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }
  
      const requestBody = {
        name: selectedCategoryName, 
        glpi_user_id_tech: 2, 
      };
  


      if (!selectedCategoryId) {
        throw new Error('ID d\'attribution non valide');
      }

      const putUrl = apiRoutes.documentsCategoriesPut.replace(':id', `${selectedCategoryId}`);


  
      const response = await fetch(putUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'special-token': specialToken
        },
        body: JSON.stringify(requestBody),
      });
  
      if (!response.ok) {
        throw new Error('Erreur lors de la mise à jour de la catégorie');
      }
  alert("Catégorie modifiée avec succès !")
      toggleOpen2(); 
      fetchData();
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la catégorie :', error);
    }
  };

  const handleDelete = async () => {
    try {
      if (!selectedCategoryId) {
        throw new Error('Aucune catégorie sélectionnée.');
      }
  
      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }

      const modelsLinkedToCategory = dataModels.some(model => model.glpi_documents_categories_id === selectedCategoryId);

      if (modelsLinkedToCategory) {
        alert('Cette catégorie ne peut pas être supprimée car des modèles lui sont liés.\n Veuillez supprimer les modèles avant de supprimer la catégorie.');
      window.location.href = '/configuration/documents/modeles';    }


      const deleteUrl = apiRoutes.documentsCategoriesDelete.replace(':id', `${selectedCategoryId}`);


      const response = await fetch(deleteUrl, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'special-token': specialToken
        },
      });
  
      if (!response.ok) {
        throw new Error('Erreur lors de la suppression de la catégorie');
      }
  alert('Catégorie supprimée !')
      toggleOpen2();
      fetchData();
    } catch (error) {
      console.error('Erreur lors de la suppression de la catégorie :', error);
    }
  };


  return (
    <div className="maindcc">

      <div className="maindcc__box1">

        <Header userName={userName} />

        <div className="maindcc__box1__container">

          <h2 className="maindcc__box1__container__title"> Configuration documents</h2>

          <div className='maindcc__box1__container__div'>

            <TabsNav tab1="Catégorie" tab2="Modèle" path1='/configuration/documents/categories' path2='/configuration/documents/modeles'/>

            <div className="maindcc__box1__container__btn">

              <Button btnName={"Nouveau"} onClick={toggleOpen} disable={false}/>

              <MDBModal id="ModalCat" open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-2'>
              <MDBModalDialog id="modaldialog">
                <MDBModalContent id="modalcontent">
                  <MDBModalHeader id='modalheader'>
                    <MDBModalTitle id="modalcattitle">Nouvelle catégorie</MDBModalTitle>
                    <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody id="modalbody">
               
                  <InputField
                  labels={labels}
                  onChange={(newValue) => setNewCategoryName(newValue[0])}
                  initialValue={[newCategoryName]}/>

                  </MDBModalBody>
                  <MDBModalFooter>
                    <ButtonSave btnName='Enregistrer' onClick={handleSave} />
                    <Button btnName='Annuler' onClick={toggleOpen} disable={false}/>
                  </MDBModalFooter>
                </MDBModalContent>
              </MDBModalDialog>
              </MDBModal>

            </div>

          </div>

          <div className="maindcc__box1__container__list">

            <TableSimple categories={data} onEdit={(id, name) => handleEdit(id, name)} />


            <MDBModal id="ModalCat2" open={basicModal2} onClose2={() => setBasicModal2(false)} tabIndex='-3'>
              <MDBModalDialog id="modaldialog2">
                <MDBModalContent id="modalcontent2">
                  <MDBModalHeader id='modalheader2'>
                    <MDBModalTitle id="modalcattitle">Modifier la catégorie</MDBModalTitle>
                    <MDBBtn
                    className='btn-close'
                    color='none'
                    onClick={() => { if (selectedCategoryId !== null) {handleEdit(selectedCategoryId, selectedCategoryName);}}}>
                    </MDBBtn>
                  </MDBModalHeader>
                  <MDBModalBody id="modalbody2">
                    <InputField 
                    labels={labels} 
                    onChange={(newValue) => setSelectedCategoryName(newValue[0])} 
                    initialValue={[selectedCategoryName]} />
                  </MDBModalBody>
                  <MDBModalFooter>
                    <ButtonSave btnName='Enregistrer' onClick={handleEditPut} />
                    <PopUp onDeleteClick={handleDelete}/>
                  </MDBModalFooter>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

          </div>

        </div>

      </div>


      <div className="maindcc__menu">

        <Menu/>

      </div>

    </div>
  );
}

export default DocCategoryConfig;
